import React, {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image2 from "../../../../assets/images/blog17-2.png";
import image18 from "../../../../assets/images/blog17-18.png";
import image37 from "../../../../assets/images/blog17-37.png";
import image23 from "../../../../assets/images/blog17-23.png";
import image5 from "../../../../assets/images/blog17-5.png";
import image8 from "../../../../assets/images/blog17-8.png";
import image26 from "../../../../assets/images/blog17-26.png";
import image60 from "../../../../assets/images/blog17-60.png";
import image10 from "../../../../assets/images/blog17-10.png";
import image35 from "../../../../assets/images/blog17-35.jpeg";
import image33 from "../../../../assets/images/blog17-33.png";
import image57 from "../../../../assets/images/blog17-57.png";
import image11 from "../../../../assets/images/blog17-11.png";
import image27 from "../../../../assets/images/blog17-27.png";
import image28 from "../../../../assets/images/blog17-28.png";
import image44 from "../../../../assets/images/blog17-44.png";

const Blog17 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook: May 5, 2025 </h2>
      </div>
      <div className="blogContentnew">
        <p
          style={{
            textAlign: "justify",
            fontFamily: "var(--header-font-family)",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "30px",
            color: "#010310",
          }}
        >
          Volatility Lurks, Macro Moves Take Centre Stage
        </p>
        <p>
          {" "}
          This week’s trading forecast unpacks sticky macro risks, a fragile technical setup in equities, and what traders should expect from Services PMIs, Central Bank speak with FOMC, BOE, Sweden
          and Norway decisions, and money flows. Stay sharp—volatility isn’t done with us yet.
        </p>
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Vol Cools, But Risks Simmer Beneath</p>
              <p>
                The SPX put in a 9 day winning streak not seen since Nov 2004. Data mainly held up and finished with a solid jobs report, earnings continue to beat and the combo saw markets snap
                back—but don’t be fooled. Beneath the relief rally, we’re staring down some persistent structural headwinds. Big tech's earnings outperformed, yet breadth remains a problem under the
                hood. Equity inflows were dominated by FANG-heavy positioning, and bond markets didn’t endorse equity optimism. European flows are ex-US, ex-UK and into Europe
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">SPX</span> rallied 2.94% on the week, fully recovering from April’s weakness.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">VIX</span>dropped into 22s, but remains elevated; hedging remains sticky at the wings.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Dollar Index (DXY)</span> held steady despite NFP upside beat, with 4 cuts still priced in.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold saw its 2nd week of decline</span> as safe haven flows rolled off <span className="highlightedText"> and oil </span>slipped again on OPEC+
                    panic pumping at the lows, a strange mix of risk on & demand down
                  </p>
                </li>
              </ul>
            </div>
            <div className="relatedImg">
              <img
                src={image2}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image2)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Sticky Inflation & Political Tension</p>
              <p>
                The Fed remains data-dependent, but markets may be underestimating just how “sticky” inflation is shaping up to be. Services PMIs dominate most Western economies and we see updates.
                ISM prices paid has been in the 60s for a few prints now will that keep trending on tariff expectation?
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">April ISM Services (Monday) </span>is the marquee risk; still a survey but an important one. Will growth hold up or is this the first crack?
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">FOMC (Wednesday) with no change expected </span>Will Powell make any response to Trump’s poking? Market is expecting 4 cuts by Dec 25.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US growth</span> is slowing: top down GDP tracking estimates have been cut and so have bottom up earnings
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image18}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image18)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Geopolitics: </span>US-China tensions re-escalated as tariffs re-enter the conversation
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image37}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image37)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">BOE set to cut while they can (Thursday) 25bps to 4.25%</span>
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image23}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image23)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Analysis: Bounce or Bull Trap?</p>
              <p>
                SPX reclaimed 5600, and held the 50-day average but still looks more like a reflex rally than a trend resumption. Breadth is still weak, and options positioning is overly reliant on
                mega-cap beta.
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Hammer Time?</span> SPX printed a Monthly chart bullish hammer—but only after a sharp 5% drop. Follow-through matters.
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Options exposure</span> remains tilted toward calls, suggesting traders are still chasing upside, not hedging.
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image8}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">VIX </span> slide continued slowly to 22, but
                    <span className="highlightedText"> VVIX </span>
                    (vol of vol) has cooled below 100 and into the upper bound of risk on.
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image26}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image26)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week in Review: NFP held up, GDP went negative, Flows Tell All. Mag4 boost</p>
              <p>Trump backed down on Powell threats but kept pushing him to cut. NFP didn’t crater this time (+175k vs. 138k expected)—cooler wage growth gave bulls cover to push higher.</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">NFP </span>was solid and cooled immediate growth fears, but was no silver bullet. UR went up but held on rounding.
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image60}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image60)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Retail flows </span>continued to favour tech-heavy funds, reinforcing the narrow rally concern.
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Meta, Microsoft, Amazon and Apple either beat or came in no worse than expected </span>justifying inflows for now
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US trade showed massive front-running</span> imports ahead of tariffs
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image44}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image44)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US Jolts showed much lower openings but Quits were high showing confidence in March</span>
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image35}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image35)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold </span>
                    drifted on lack of fear with bulls all in but <span className="highlightedText">Treasuries </span>saw defensive demand on heightened recession fears ahead—a classic sign of macro
                    confusion.
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image33}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image33)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <p className="highlightedBoldText">The Week Ahead: ISM Services looms, Sentiment Shifts, Global Macro in Motion</p>
        <p>Much slower week with a Services slant—excitement maybe midweek with FOMC Fed-speak and BOE decisions. With sentiment already fragile, even “secondary” data could fuel volatility.</p>

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <div className="WrapperSet_left">
                <div className="contentwrapped">
                  <p className=" highlightedText_header">Monday, May 5</p>
                  <ul className="pointersSection">
                    <li className="themesPointer">
                      <p>
                        <span className="highlightedText">CHF CPI everything pointing to intervention </span>and more rate cuts; heading towards deflation fast
                      </p>
                    </li>
                    <li className="themesPointer">
                      <p>
                        <span className="highlightedText">US ISM Services PMI (Apr) </span>– The big one today. After last week’s ISM Manufacturing miss, a weak print here would confirm growth fears.
                      </p>
                    </li>
                  </ul>
                </div>

                <div className="relatedImg">
                  <img
                    src={image57}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image57)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div className="WrapperSet">
                <div className="contentwrapped">
                  <p className="highlightedText_header">Tuesday, May 6</p>
                  <ul className="pointersSection">
                    <li className="themesPointer">
                      <p>
                        <span className="highlightedText">Eurozone Services PMI (Final, Apr)</span>– Still stuck in stall speed. Little hope for big upside surprise.
                      </p>
                    </li>
                    <li className="themesPointer">
                      <p>
                        <span className="highlightedText">IBD/TIPP Economic Optimism Index</span>– Important context for how households are perceiving inflation and policy.
                      </p>
                    </li>
                  </ul>
                </div>

                <div className="relatedImg">
                  <img
                    src={image11}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image11)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div className="WrapperSet_left">
                <div className="contentwrapped">
                  <p className="highlightedText_header">Wednesday, May 7</p>
                  <ul className="pointersSection">
                    <li className="themesPointer">
                      <p>
                        <span className="highlightedText">No major data scheduled –</span>
                        Likely a positioning and digestion day.
                      </p>
                    </li>
                    <li className="themesPointer">
                      <p>
                        <span className="highlightedText">Traders will be leaning into FOMC setups; </span>
                        options positioning should get more skewed.
                      </p>
                    </li>
                  </ul>
                </div>

                <div className="relatedImg">
                  <img
                    src={image8}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <div className="WrapperSet">
                <div className="contentwrapped">
                  <p className="highlightedText_header">Thursday, May 8</p>
                  <ul className="pointersSection">
                    <li className="themesPointer">
                      <p>
                        <span className="highlightedText">Jobless Claims –</span>Saw a big jump last week that was too late to make it into the NFP survey; any further rise could stoke slowdown fears.
                      </p>
                    </li>
                    <li className="themesPointer">
                      <p>
                        <span className="highlightedText">Wholesale Inventories (Mar Final) –</span>Backwards-looking but still useful for tracking goods demand.
                      </p>
                    </li>
                    <li className="themesPointer">
                      <p>
                        <span className="highlightedText">BOE decision…25bps cut expected to 4.25% </span>enough to see inflows into the UK?
                      </p>
                    </li>
                  </ul>
                </div>

                <div className="relatedImg">
                  <img
                    src={image27}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image27)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div className="WrapperSet_left">
                <div className="contentwrapped">
                  <p className="highlightedText_header">Friday, May 9</p>
                  <ul className="pointersSection">
                    <li className="themesPointer">
                      <p>
                        <span className="highlightedText">UK March Industrial Production</span> – could confirm stagflationary pressures but should be post a rate cut. The FTSE100 has risen despite
                        outflows anyway
                      </p>
                    </li>
                    <li className="themesPointer">
                      <p>
                        <span className="highlightedText">Canadian employment –</span> Any tariff destruction yet for the 51st State?
                      </p>
                    </li>
                  </ul>
                </div>

                <div className="relatedImg">
                  <img
                    src={image28}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image28)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Don’t Trust the Bounce, Macro Risks Still Bite</p>
              <p>
                Last week’s bounce felt good, but it wasn’t healthy. The rally was driven by <span className="highlightedText">gamma flow, light positioning, </span>and{" "}
                <span className="highlightedText">relief of it could have been worse, </span>not real conviction. Beneath the surface, data is seen deteriorating but holding on for now, breadth
                remains poor, and defensive assets like <span className="highlightedText">gold and bonds </span>are still catching solid bids within some volatility.
              </p>
              <p>
                The market is not trading a soft landing—it’s trading a <span className="highlightedText">short squeeze in a shallow pool </span> of liquidity.
              </p>
              <p>Here’s what matters:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">SPX breadth remains weak. </span> Only 43% of S&P names are above their 50-day MA. Big tech is doing the heavy lifting.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Positioning is light.</span> CTA net exposure is still off the highs, and retail is hesitant.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold remains bid </span>despite equity upside, classic defensive behaviour.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Bond yields fell</span> until a strong, mixed NFP.
                    <span className="highlightedText"> Growth fears remain</span> this is not a risk-on green light yet.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">
                      Earnings have not cratered to the April call down levels but have not been re-rated for the remainder of the year yet. SPX 5680 is 21x forward FY25 earnings
                    </span>
                    -Muddled ground and large sellers came in on Thursday night. Danger of driftback remains
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1YSpAHxe4jdcD2G2hNOfhO5U5sqVBhu174QBl87wfxW8/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog17;
